import { useState } from "react";
import Tree from "./Tree";

export default function TreeNode({ name, node, onFileClick, searchTerm }) {
  const [open, setOpen] = useState(true);
  const match =
    searchTerm && name.toLowerCase().includes(searchTerm.toLowerCase());

  return (
    <li>
      <div
        className={`tree-node ${match ? "match" : ""}`}
        onClick={() => (node.isFile ? onFileClick(node) : setOpen(!open))}
      >
        {node.isFile ? "📄" : open ? "📂" : "📁"} {name}
      </div>

      {!node.isFile && open && (
        <Tree
          nodes={node.children}
          onFileClick={onFileClick}
          searchTerm={searchTerm}
        />
      )}
    </li>
  );
}